const HomeVideoPushIntegrated = ({language , token}) => {
    const newHomeVideoPushIframe = "https:" +
    window.process.env.URL_Home_Videopush
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_homeVideoPush_display"
        src={newHomeVideoPushIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default HomeVideoPushIntegrated